export const sapModulesData = {
  // ---- Technical Modules (Basis / Development) ----
  'SAP ABAP (Advanced Business Application Programming)': [
    'ABAP programming',
    'Reports (ALV)',
    'Forms (SmartForms, Adobe)',
    'Enhancements & User Exits',
    'BAPIs, BADIs',
    'OData service development',
    'CDS Views & AMDP',
    'SAP Gateway',
    'Performance tuning',
    'Object-Oriented ABAP',
    'Module Pool (Dialog Programming)',
    'IDocs/ALE',
    'RFC',
  ],
  'SAP BASIS': [
    'System administration',
    'User and authorization management',
    'Transport Management System (TMS)',
    'Kernel upgrades & patches',
    'Performance monitoring (ST03, ST06, etc.)',
    'Client copies and system refreshes',
    'SAP HANA administration (if applicable)',
    'System Landscape Directory (SLD)',
    'Backup and Recovery',
    'High Availability and Disaster Recovery (HA/DR)',
  ],
  'SAP BTP (Business Technology Platform) / Cloud Platform': [
    'SAP CAP (Cloud Application Programming Model)',
    'SAP Fiori/UI5 Development (on BTP)',
    'Cloud Foundry runtime',
    'Kyma runtime',
    'Destination and connectivity services',
    'BTP Security & Identity Authentication Service (IAS)',
    'SAP HANA Cloud',
    'SAP Integration Suite (Cloud Integration/CPI)',
    'SAP Build Apps (formerly AppGyver)',
    'SAP Build Process Automation',
    'Event Mesh',
    'BTP Cockpit administration',
  ],
  'SAP NetWeaver (Traditional On-Premise Platform Components)': [
    'Portal development (SAP Enterprise Portal)',
    'Web Dynpro for ABAP/Java',
    'PI/PO (Process Integration / Orchestration)',
    'SSO & SAML configuration',
    'Application Server (AS ABAP, AS Java) administration',
    'Identity Management (IDM)',
  ],

  // ---- Functional Modules ----
  'SAP FI (Financial Accounting)': [
    'General Ledger (GL) Accounting',
    'Accounts Payable (AP)',
    'Accounts Receivable (AR)',
    'Asset Accounting (AA)',
    'Bank Accounting (Electronic Bank Statement, DMEE)',
    'Taxation configuration (Input/Output Tax)',
    'Financial reporting (via Fiori, SAP GUI, Financial Statement Versions)',
    'New General Ledger (New G/L)',
    'Parallel Accounting',
    'Month-end and Year-end closing processes',
    'Integration with MM/SD/CO',
  ],
  'SAP CO (Controlling)': [
    'Cost Center Accounting (CCA)',
    'Profit Center Accounting (PCA)',
    'Internal Orders',
    'Product Costing (CO-PC) - Planned Cost, Actual Cost',
    'Profitability Analysis (CO-PA) - Costing-based, Account-based',
    'Material Ledger (ML)',
    'Reporting (Report Painter, Report Writer)',
  ],
  'SAP MM (Materials Management)': [
    'Procurement Processes (Purchase Requisition, Purchase Order)',
    'Inventory Management (Goods Receipt, Goods Issue, Stock Transfers)',
    'Vendor Master Data',
    'Material Master Data',
    'Source Lists & Info Records',
    'Invoice Verification (MIRO, LIV)',
    'Subcontracting Process',
    'Consignment Process',
    'Physical Inventory',
    'Material Requirements Planning (MRP) - MM aspects',
  ],
  'SAP SD (Sales and Distribution)': [
    'Order-to-Cash (OTC) process',
    'Sales Order Management (Inquiry, Quotation, Sales Order)',
    'Pricing procedure configuration (Condition Technique)',
    'Delivery Processing (Outbound Delivery, Picking, Packing, PGI)',
    'Billing Processes (Invoices, Credit/Debit Memos)',
    'Credit Management',
    'Customer Master Data',
    'Availability Check (ATP)',
    'Route Determination',
    'Revenue Account Determination',
  ],
  'SAP PP (Production Planning)': [
    'Bill of Materials (BOM)',
    'Routing',
    'MRP (Material Requirement Planning)',
    'Work Center Configuration',
    'Shop Floor Control',
    'Production Orders / Process Orders',
    'Demand Management',
    'Capacity Planning',
    'Repetitive Manufacturing',
    'Kanban',
  ],
  'SAP QM (Quality Management)': [
    'Inspection Plans',
    'Quality Notifications',
    'Result Recording',
    'Usage Decision (UD)',
    'Quality Certificates',
    'Batch Management (QM aspects)',
    'Stability Studies',
  ],
  'SAP PM (Plant Maintenance)': [
    'Maintenance Orders (Corrective, Preventive)',
    'Task Lists & Notifications',
    'Preventive Maintenance plans',
    'Equipment Management (Functional Locations, Equipment Master)',
    'Refurbishment Process',
    'Measurement Points and Counters',
  ],
  'SAP HCM / HR (Human Capital Management)': [
    'Personnel Administration (PA)',
    'Organizational Management (OM)',
    'Time Management (Positive/Negative, Work Schedules, Quotas)',
    'Payroll Configuration (Country-specific)',
    'Employee Self-Service (ESS) / Manager Self-Service (MSS)',
    'Recruitment (E-Recruiting)',
    'Talent Management',
    'Learning Solution (LSO)',
    'Compensation Management',
    'Benefits Administration',
    'SuccessFactors (Employee Central, Recruiting, Onboarding, etc.)',
  ],

  // ---- Cloud & Digital Transformation ----
  'SAP Fiori / SAPUI5 (Frontend Development)': [
    'JavaScript, HTML5, CSS',
    'XML Views',
    'OData Integration (consuming services)',
    'Custom Fiori app development',
    'Fiori Elements & Smart Controls',
    'UI Theme Designer',
    'Fiori Launchpad configuration',
    'SAP Business Application Studio (BAS) for UI5 dev',
  ],
  'SAP S/4HANA (Specifics & Transformation)': [
    'S/4HANA Finance (Simple Finance)',
    'S/4HANA Logistics (Simple Logistics - MM, SD, PP integration)',
    'Embedded Analytics (CDS Views, Fiori Analytical Apps)',
    'Universal Journal (ACDOCA)',
    'Simplified Data Models (e.g., MATDOC)',
    'SAP Activate methodology',
    'S/4HANA Migration Skills (Brownfield/Greenfield/Bluefield)',
    'Business Partner Concept (CVI Integration)',
    'Central Finance (CFIN)',
  ],
  'SAP Analytics Cloud (SAC)': [
    'Story building & visualizations',
    'Predictive analytics features (Smart Predict, Smart Insights)',
    'Data connectivity (Live/Import to S/4HANA, BW, etc.)',
    'Planning Models (Financial Planning, Sales Planning)',
    'Business Intelligence (BI) features',
    'Digital Boardroom',
    'Application Design (for custom analytic apps)',
  ],

  // ---- Integration Modules ----
  'SAP PI/PO / SAP Integration Suite (CPI)': [
    'iFlows development (in SAP CPI)',
    'Message Mapping (Graphical/XSLT/Groovy)',
    'Adapters (IDoc, SOAP, REST, RFC, JDBC, File, Mail, OData, SFTP, etc.)',
    'Error handling & monitoring (Message Monitoring, PIMON)',
    'Groovy scripting (for CPI custom logic)',
    'JavaScript scripting (for CPI custom logic)',
    'API Management (within Integration Suite)',
    'Event Mesh (within Integration Suite)',
    'B2B Integration (EDI, AS2, Trading Partner Management)',
  ],

  // ---- Warehouse & Logistics ----
  'SAP EWM (Extended Warehouse Management)': [
    'Warehouse Structure (Storage Types, Sections, Bins)',
    'Inbound Processing (Putaway strategies)',
    'Outbound Processing (Stock Removal strategies, Wave Picking)',
    'Storage Bins, Handling Units (HU Management)',
    'RF (Radio Frequency) Framework Integration & Customization',
    'Physical Inventory in EWM',
    'Cross-Docking',
    'Slotting and Rearrangement',
    'Yard Management (optional)',
  ],
  'SAP TM (Transportation Management)': [
    'Freight Order Planning & Execution',
    'Carrier Management & Selection',
    'Route Optimization & Determination',
    'Freight Settlement',
    'Integration with EWM/MM/SD',
    'Transportation Network configuration',
    'Charge Calculation',
  ],

  // ---- Industry & Niche Modules ----
  'SAP IS-Retail (Industry Solution for Retail)': [
    'Assortment Management (Listing, Layouts)',
    'Store Merchandise and Inventory Management',
    'Article Master Data (Retail specific fields)',
    'Promotions and Pricing (Retail specific)',
    'POS Data Management (POSDM)',
    'Merchandise Category Management',
  ],
  'SAP CRM (Customer Relationship Management - On-Premise)': [
    'Interaction Center (IC WebClient)',
    'Campaign Management',
    'Opportunity Management (Sales Pipeline)',
    'Service and Support (Service Orders, Complaints)',
    'Lead Management',
    'Loyalty Management',
    'Middleware (CRM data exchange with ERP)',
  ],
  'SAP C4C / Sales Cloud / Service Cloud (CX Suite)': [
    // Modern Cloud CRM
    'Sales Cloud (Lead, Opportunity, Quote, Order Management)',
    'Service Cloud (Ticketing, Case Management, Field Service)',
    'Customer Data Platform (CDP)',
    'Marketing Cloud (Campaigns, Email Marketing)',
    'Integration with S/4HANA',
  ],
  'SAP SRM (Supplier Relationship Management - On-Premise)': [
    'Supplier Self-Service (SUS)',
    'Sourcing and Contract Management',
    'Procurement Catalogs (Internal, External)',
    'Plan-Driven Procurement (PDP)',
    'Shopping Cart (SC) processing',
  ],
  'SAP Ariba (Cloud Procurement)': [
    'Ariba Sourcing',
    'Ariba Contracts',
    'Ariba Buying and Invoicing (P2P)',
    'Ariba Supplier Lifecycle and Performance (SLP)',
    'Ariba Network integration',
  ],
  'SAP APO / IBP (Advanced Planning & Optimization / Integrated Business Planning)':
    [
      'Demand Planning (DP in APO, Demand Sensing in IBP)',
      'Supply Network Planning (SNP in APO, S&OP in IBP)',
      'Response and Supply Planning (IBP)',
      'SAP IBP Time Series & Order-based Planning',
      'Production Planning and Detailed Scheduling (PP/DS in APO/S4)',
      'Global Available-to-Promise (gATP in APO)',
    ],

  // ---- Security & Governance ----
  'SAP GRC (Governance, Risk, Compliance)': [
    'Access Control (AC - ARA, ARM, BRM, EAM)',
    'Risk Management (RM)',
    'Process Control (PC)',
    'Audit Management (AM)',
    'Segregation of Duties (SoD) analysis',
    'Emergency Access Management (Firefighter)',
  ],
  'SAP Security (General)': [
    'Role and Authorization design/implementation',
    'PFCG role maintenance',
    'SU01 User Administration',
    'Security Audit Log (SM20, SM19)',
    'Understanding of SoD concepts',
    'Securing RFC connections',
    'Data encryption and masking concepts',
  ],

  // ---- Other/General Skills ----
  'General Project & Soft Skills': [
    'Project Management (Agile, Waterfall)',
    'Business Analysis',
    'Requirement Gathering',
    'Solution Design',
    'Testing (Unit, Integration, UAT)',
    'Documentation (Functional Specs, Technical Specs, User Manuals)',
    'Communication Skills',
    'Problem Solving',
    'Client Facing Experience',
    'Change Management',
  ],
  'Data Migration & Management': [
    'LSMW (Legacy System Migration Workbench)',
    'SAP Data Services (BODS)',
    'Migration Cockpit (S/4HANA)',
    'Data Archiving',
    'Master Data Governance (MDG)',
  ],
};

export const generalJobRolesData = {
  // ---- Software Development ----
  'Full Stack Developer': [
    'HTML5, CSS3, JavaScript (ES6+)',
    'React.js, Angular, or Vue.js',
    'Node.js, Express.js',
    'RESTful APIs and GraphQL',
    'Database design (SQL and NoSQL)',
    'MongoDB, PostgreSQL, MySQL',
    'Git version control',
    'Docker and containerization',
    'CI/CD pipelines',
    'AWS/Azure/GCP cloud services',
    'Testing frameworks (Jest, Mocha)',
    'Agile/Scrum methodologies',
    'Authentication and authorization',
    'Performance optimization',
    'Responsive design principles',
  ],
  'Frontend Developer': [
    'HTML5, CSS3, JavaScript (ES6+)',
    'React.js, Angular, Vue.js',
    'TypeScript',
    'Responsive web design',
    'CSS preprocessors (Sass, Less)',
    'Webpack, Vite, Parcel',
    'State management (Redux, Vuex, Context API)',
    'RESTful API integration',
    'Testing (Jest, Cypress, Testing Library)',
    'Web accessibility (WCAG)',
    'Cross-browser compatibility',
    'Performance optimization',
    'Progressive Web Apps (PWAs)',
    'UI/UX design principles',
    'Version control (Git)',
  ],
  'Backend Developer': [
    'Server-side programming (Node.js, Python, Java, C#)',
    'RESTful API development',
    'GraphQL',
    'Database design and optimization',
    'SQL and NoSQL databases',
    'Authentication and authorization',
    'Microservices architecture',
    'Docker and containerization',
    'Cloud platforms (AWS, Azure, GCP)',
    'Message queues (RabbitMQ, Apache Kafka)',
    'Caching strategies (Redis, Memcached)',
    'API documentation (Swagger/OpenAPI)',
    'Testing frameworks',
    'Performance monitoring',
    'Security best practices',
  ],
  'Python Developer': [
    'Python 3.x programming',
    'Django, Flask, FastAPI',
    'RESTful API development',
    'SQL and ORM (SQLAlchemy, Django ORM)',
    'PostgreSQL, MySQL, SQLite',
    'Git version control',
    'Testing (pytest, unittest)',
    'Docker and containerization',
    'AWS/Azure cloud services',
    'CI/CD pipelines',
    'Web scraping (BeautifulSoup, Scrapy)',
    'Task queues (Celery, RQ)',
    'Data analysis libraries (Pandas, NumPy)',
    'API integration',
    'Linux/Unix command line',
  ],
  'Java Developer': [
    'Java SE/EE development',
    'Spring Framework (Spring Boot, Spring MVC)',
    'Hibernate/JPA',
    'RESTful web services',
    'Maven/Gradle build tools',
    'MySQL, PostgreSQL, Oracle',
    'JUnit testing framework',
    'Git version control',
    'Docker and Kubernetes',
    'Microservices architecture',
    'Apache Kafka, RabbitMQ',
    'CI/CD pipelines',
    'AWS/Azure cloud platforms',
    'Design patterns',
    'Agile development methodologies',
  ],
  '.NET Developer': [
    'C# programming',
    'ASP.NET Core, ASP.NET MVC',
    'Entity Framework Core',
    'RESTful API development',
    'SQL Server, PostgreSQL',
    'Azure cloud services',
    'Visual Studio/VS Code',
    'Git version control',
    'NUnit/xUnit testing',
    'Docker containerization',
    'Blazor framework',
    'SignalR for real-time applications',
    'Identity and authentication',
    'LINQ and lambda expressions',
    'Dependency injection patterns',
  ],
  'React Developer': [
    'React.js and React Hooks',
    'JavaScript (ES6+) and TypeScript',
    'JSX and component-based architecture',
    'State management (Redux, Context API, Zustand)',
    'React Router for navigation',
    'RESTful API integration',
    'CSS-in-JS (Styled Components, Emotion)',
    'Testing (Jest, React Testing Library)',
    'Webpack and build tools',
    'Git version control',
    'Performance optimization',
    'Responsive design',
    'Next.js framework',
    'GraphQL and Apollo Client',
    'UI component libraries',
  ],
  'Angular Developer': [
    'Angular framework (Angular 12+)',
    'TypeScript programming',
    'Angular CLI',
    'RxJS and observables',
    'Angular Material or PrimeNG',
    'RESTful API integration',
    'NgRx state management',
    'Angular testing (Jasmine, Karma)',
    'Git version control',
    'HTML5, CSS3, SCSS',
    'Responsive web design',
    'Angular routing',
    'Dependency injection',
    'Angular forms (reactive and template-driven)',
    'PWA development',
  ],
  'Vue.js Developer': [
    'Vue.js framework (Vue 3)',
    'JavaScript (ES6+) and TypeScript',
    'Vue CLI and Vite',
    'Vuex/Pinia state management',
    'Vue Router',
    'RESTful API integration',
    'Vue component libraries (Vuetify, Quasar)',
    'Testing (Vue Test Utils, Jest)',
    'Git version control',
    'HTML5, CSS3, SCSS',
    'Webpack configuration',
    'Nuxt.js framework',
    'Vue composition API',
    'Responsive design',
    'Performance optimization',
  ],
  // ---- Mobile Development ----
  'React Native Developer': [
    'React Native framework',
    'JavaScript (ES6+) and TypeScript',
    'React and React Hooks',
    'Mobile UI/UX principles',
    'iOS and Android development concepts',
    'React Navigation',
    'State management (Redux, Context API)',
    'RESTful API integration',
    'Native module integration',
    'Push notifications',
    'App Store and Google Play deployment',
    'Testing (Jest, Detox)',
    'Git version control',
    'Performance optimization',
    'Device-specific features (camera, GPS)',
  ],
  'Flutter Developer': [
    'Dart programming language',
    'Flutter framework',
    'Flutter widgets and state management',
    'Provider, BLoC, or Riverpod',
    'RESTful API integration',
    'Firebase services',
    'SQLite and local storage',
    'Material Design and Cupertino',
    'iOS and Android deployment',
    'Git version control',
    'Testing (unit, widget, integration)',
    'Performance optimization',
    'Platform-specific code',
    'Push notifications',
    'App store publishing',
  ],
  'iOS Developer': [
    'Swift programming',
    'Xcode IDE',
    'UIKit and SwiftUI',
    'iOS SDK and frameworks',
    'Core Data and SQLite',
    'RESTful API integration',
    'Auto Layout and Interface Builder',
    'MVC and MVVM patterns',
    'Git version control',
    'TestFlight and App Store deployment',
    'Push notifications (APNs)',
    'CocoaPods and Swift Package Manager',
    'Unit and UI testing',
    'Performance optimization',
    'Apple Human Interface Guidelines',
  ],
  'Android Developer': [
    'Kotlin and Java programming',
    'Android Studio IDE',
    'Android SDK and APIs',
    'Activities, Fragments, Services',
    'Room database and SQLite',
    'RESTful API integration',
    'Material Design principles',
    'MVVM and MVP patterns',
    'Git version control',
    'Google Play Console deployment',
    'Firebase services',
    'Gradle build system',
    'JUnit and Espresso testing',
    'Performance optimization',
    'Android Jetpack components',
  ],
  // ---- Data Science & AI/ML ----
  'Data Scientist': [
    'Python (Pandas, NumPy, Scikit-learn)',
    'R programming',
    'Statistical analysis and modeling',
    'Machine learning algorithms',
    'Data visualization (Matplotlib, Seaborn, Plotly)',
    'SQL and database querying',
    'Jupyter notebooks',
    'Feature engineering',
    'A/B testing and experimental design',
    'Big data tools (Spark, Hadoop)',
    'Cloud platforms (AWS, Azure, GCP)',
    'Git version control',
    'Data cleaning and preprocessing',
    'Business intelligence tools',
    'Communication and presentation skills',
  ],
  'Machine Learning Engineer': [
    'Python programming (Scikit-learn, TensorFlow, PyTorch)',
    'Machine learning algorithms and techniques',
    'Model deployment and productionization',
    'MLOps and ML pipelines',
    'Docker and containerization',
    'Cloud ML services (AWS SageMaker, Azure ML)',
    'Data preprocessing and feature engineering',
    'Model monitoring and maintenance',
    'REST APIs for ML models',
    'Git version control and MLflow',
    'SQL and NoSQL databases',
    'Distributed computing (Spark, Dask)',
    'Model optimization and performance tuning',
    'A/B testing for ML models',
    'Software engineering best practices',
  ],
  'AI Engineer': [
    'Python and deep learning frameworks (TensorFlow, PyTorch)',
    'Neural networks and deep learning',
    'Natural Language Processing (NLP)',
    'Computer Vision',
    'Large Language Models (LLMs)',
    'AI model deployment and scaling',
    'Cloud AI services',
    'MLOps and model lifecycle management',
    'Data pipeline development',
    'API development for AI services',
    'Git version control',
    'Statistical modeling',
    'Prompt engineering',
    'AI ethics and responsible AI',
    'Research and development skills',
  ],
  'Data Engineer': [
    'Python programming',
    'SQL and database design',
    'ETL/ELT pipeline development',
    'Apache Spark, Kafka, Airflow',
    'Cloud data platforms (AWS, Azure, GCP)',
    'Data warehousing (Snowflake, Redshift, BigQuery)',
    'NoSQL databases (MongoDB, Cassandra)',
    'Docker and Kubernetes',
    'Git version control',
    'Data modeling and schema design',
    'Stream processing',
    'Data governance and quality',
    'Linux/Unix systems',
    'Distributed systems',
    'Performance optimization',
  ],
  'Data Analyst': [
    'SQL for data querying',
    'Excel and Google Sheets advanced features',
    'Python or R for data analysis',
    'Data visualization (Tableau, Power BI, Looker)',
    'Statistical analysis',
    'Business intelligence concepts',
    'Data cleaning and preprocessing',
    'Dashboards and reporting',
    'Data validation',
    'A/B testing interpretation',
    'Communication of insights',
    'ETL understanding',
    'Version control (Git) basics',
    'Presentation skills',
    'Domain knowledge (e.g., finance, marketing)',
  ],
  // ---- Cloud & DevOps ----
  'DevOps Engineer': [
    'CI/CD pipelines (Jenkins, GitLab CI, GitHub Actions)',
    'Docker and Kubernetes',
    'Cloud platforms (AWS, Azure, GCP)',
    'Infrastructure as Code (Terraform, CloudFormation)',
    'Configuration management (Ansible, Chef, Puppet)',
    'Scripting (Bash, Python)',
    'Linux administration',
    'Monitoring and logging (Prometheus, Grafana, ELK Stack)',
    'Version control (Git)',
    'Networking concepts',
    'Security best practices (DevSecOps)',
    'Container orchestration',
    'Automation tools',
    'Troubleshooting and problem-solving',
    'Agile methodologies',
  ],
  'Cloud Engineer (AWS/Azure/GCP)': [
    'Cloud platform services (EC2, S3, Lambda, Azure VMs, Blob Storage, GCE, GCS)',
    'Networking (VPC, VNet, Cloud VPN)',
    'Security best practices in cloud',
    'Cloud cost optimization',
    'Infrastructure as Code (Terraform, CloudFormation)',
    'Containerization (Docker, Kubernetes)',
    'Serverless computing',
    'Monitoring and logging in cloud',
    'Disaster recovery and backup',
    'Identity and Access Management (IAM)',
    'Database services (RDS, Azure SQL DB, Cloud SQL)',
    'Load balancing and auto-scaling',
    'Migration strategies to cloud',
    'Cloud governance',
    'Certification in relevant cloud platform',
  ],
  'Site Reliability Engineer (SRE)': [
    'Systems engineering fundamentals',
    'Automation and scripting (Python, Go, Bash)',
    'Incident response and management',
    'Monitoring and alerting (Prometheus, Grafana)',
    'Logging and tracing (ELK Stack, Jaeger)',
    'Post-mortem analysis',
    'On-call rotations',
    'Service Level Objectives (SLOs) and SLIs',
    'Distributed systems',
    'Cloud platforms (AWS, Azure, GCP)',
    'Kubernetes and Docker',
    'Performance tuning and optimization',
    'Chaos engineering',
    'Networking concepts',
    'Capacity planning',
  ],
  // ---- Cybersecurity ----
  'Cybersecurity Analyst': [
    'Network security (Firewalls, IDS/IPS)',
    'Endpoint security',
    'Vulnerability assessment and penetration testing (VA/PT)',
    'Security Information and Event Management (SIEM)',
    'Incident response and handling',
    'Threat intelligence',
    'Malware analysis',
    'Cloud security',
    'Identity and Access Management (IAM)',
    'Cryptography basics',
    'Security policies and compliance (NIST, ISO 27001)',
    'Phishing and social engineering awareness',
    'Security awareness training',
    'Risk management',
    'Scripting (Python, PowerShell)',
  ],
  'Security Engineer': [
    'Designing and implementing security architectures',
    'Cloud security (AWS, Azure, GCP security services)',
    'Application security (SAST, DAST)',
    'Network security engineering',
    'Identity and Access Management (IAM) solutions',
    'Encryption technologies (PKI, SSL/TLS)',
    'Security automation',
    'DevSecOps principles',
    'Vulnerability management',
    'Intrusion detection/prevention systems',
    'Security compliance frameworks',
    'Scripting for security tasks (Python)',
    'Container security',
    'Security auditing and logging',
    'Risk assessment and mitigation',
  ],
  // ---- Product & Project Management ----
  'Product Manager': [
    'Product lifecycle management',
    'Market research and analysis',
    'User empathy and research',
    'Roadmap development and prioritization',
    'Agile/Scrum methodologies',
    'Requirements gathering and user stories',
    'Cross-functional team collaboration',
    'Go-to-market strategy',
    'Data-driven decision making',
    'Competitive analysis',
    'Product strategy and vision',
    'Stakeholder management',
    'UI/UX principles',
    'A/B testing',
    'Communication and presentation skills',
  ],
  'Project Manager': [
    'Project planning and execution',
    'Scope, time, and cost management',
    'Risk management',
    'Stakeholder management',
    'Communication planning',
    'Agile, Scrum, Waterfall methodologies',
    'Resource allocation',
    'Budget management',
    'Conflict resolution',
    'Team leadership and motivation',
    'Reporting and documentation',
    'Quality assurance',
    'Microsoft Project, Jira, Asana',
    'Change management',
    'Problem-solving skills',
  ],
  'Scrum Master': [
    'Facilitating Scrum ceremonies (daily stand-ups, sprint planning, reviews, retrospectives)',
    'Coaching Agile principles and practices',
    'Removing impediments for the team',
    'Protecting the team from external interruptions',
    'Conflict resolution within the team',
    'Metrics and reporting (burndown charts)',
    'Jira, Azure DevOps, Trello',
    'Servant leadership',
    'Continuous improvement',
    'Communication and interpersonal skills',
    'Understanding of scaling Agile (SAFe, LeSS) (optional)',
    'Technical understanding (beneficial)',
    'Adaptability',
    'Problem-solving',
    'Team building',
  ],
  // ---- Data & Analytics ----
  'Business Intelligence (BI) Developer': [
    'SQL for data extraction and manipulation',
    'ETL processes and tools (SSIS, Talend, Informatica)',
    'Data warehousing concepts (Kimball, Inmon)',
    'BI tools (Tableau, Power BI, QlikView, Looker)',
    'Data modeling and schema design',
    'Dashboard and report development',
    'Data visualization best practices',
    'Performance tuning of queries and reports',
    'Data governance and quality',
    'Python/R for scripting (optional)',
    'Cloud BI services (AWS QuickSight, Azure Synapse)',
    'Problem-solving and analytical skills',
    'Communication with business users',
    'Data security principles',
    'Version control for BI assets',
  ],
  // ---- IT Support & Administration ----
  'IT Support Specialist / Help Desk': [
    'Troubleshooting hardware and software issues',
    'Operating systems (Windows, macOS, Linux)',
    'Network fundamentals (TCP/IP, DNS, DHCP)',
    'Microsoft Office Suite / Google Workspace',
    'Ticketing systems (ServiceNow, Zendesk)',
    'User account management (Active Directory)',
    'Printer and peripheral setup',
    'Remote support tools',
    'Basic cybersecurity awareness',
    'Customer service skills',
    'Documentation of solutions',
    'Mobile device support',
    'Endpoint management',
    'Backup and recovery procedures',
    'Antivirus and malware removal',
  ],
  'System Administrator (Windows/Linux)': [
    'Operating system administration (Windows Server, Red Hat, Ubuntu)',
    'Scripting (PowerShell, Bash, Python)',
    'Virtualization (VMware, Hyper-V)',
    'Active Directory and Group Policy (for Windows)',
    'Network services (DNS, DHCP, IIS, Apache, Nginx)',
    'Storage management (SAN, NAS)',
    'Backup and disaster recovery',
    'Patch management',
    'Monitoring tools (Nagios, Zabbix)',
    'Automation tools (Ansible, Puppet)',
    'Cloud basic administration (AWS, Azure, GCP)',
    'Troubleshooting system issues',
    'Security hardening',
    'Hardware maintenance',
    'Documentation',
  ],
  // ---- ERP (General) ----
  'ERP Consultant (General)': [
    'Understanding of core ERP modules (e.g., Finance, HR, Supply Chain)',
    'Business process analysis and re-engineering',
    'Requirements gathering and documentation',
    'System configuration and customization',
    'User training and support',
    'Data migration strategies',
    'Integration concepts (APIs, middleware)',
    'Project lifecycle methodologies',
    'Stakeholder management',
    'Gap analysis',
    'Testing (unit, integration, UAT)',
    'Troubleshooting ERP issues',
    'Reporting and analytics within ERP',
    'Communication and presentation skills',
    'Industry-specific ERP knowledge (e.g., manufacturing, retail)',
  ],
};

// Combine all job roles into a single object for easier access
export const allJobRolesData = {
  ...sapModulesData,
  ...generalJobRolesData,
};

export const experienceYearsRanges = [
  '0-1 years',
  '1-3 years',
  '3-5 years',
  '5-7 years',
  '7-10 years',
  '10-15 years',
  '15+ years',
];
